import React from 'react';

function getClass(current, selected, selectedClassName) {
    if (current === selected) return selectedClassName;
    return '';
}

const ItemSelector = ({
    items, children, selected, onSelect,
    selectedClassName = 'text-portal-blue-primary underline',
    hoverClassName = 'hover:text-portal-blue-primary'
}) => {
    return (
        <>
            {items.map((item, i) =>
                <div className="flex flex-row" key={i}>
                    <span className={`cursor-pointer select-none ${hoverClassName} ${getClass(item, selected, selectedClassName)}`}
                        onClick={() => onSelect(item)}>
                        {item}
                    </span>
                    {i < items.length - 1 ? <span className="cursor-default select-none">{children}</span> : null}
                </div>
            )
            }
        </ >
    );
};

export default ItemSelector;
